export const environment = {
    production: false,
    apiURL: 'http://localhost:3300/api/',
    authURL: 'http://localhost:3300/api/autorizzazione',
    loginURL: 'http://localhost:3300/api/login',
    // apiURL: 'https://teatrocolosseo-api.lamptest.ipsnet.it/api/',
    // authURL: 'https://teatrocolosseo-api.lamptest.ipsnet.it/api/autorizzazione',
    // loginURL: 'https://teatrocolosseo-api.lamptest.ipsnet.it/api/login',
    mapboxgl: {
        accessToken: 'pk.eyJ1IjoiYWFudG9uYWNjaS1tb25pdG9yYXRvIiwiYSI6ImNtMXVrMmQ1bjAxd3YyanBpNjM0d3B4YWgifQ.twEQHci6hYKSUnFNrp76Mw'
    },
};
